var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadDisabledIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 8414",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 8413"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 3752",
    d: "M1 12.8167V14.4486C1 14.9769 1.21739 15.4836 1.60439 15.8573C1.9914 16.2309 2.51632 16.441 3.06375 16.4412H15.1188C15.6664 16.4412 16.1915 16.2313 16.5788 15.8576C16.966 15.4839 17.1835 14.9771 17.1835 14.4486V12.8167",
    stroke: "#948B9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 683",
    d: "M9.09169 1V11.7522",
    stroke: "#948B9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 3753",
    d: "M13.0799 8.44214L9.98908 11.4251C9.86925 11.5408 9.72696 11.6326 9.57035 11.6952C9.41373 11.7579 9.24588 11.7901 9.07635 11.7901C8.90682 11.7901 8.73894 11.7579 8.58232 11.6952C8.42571 11.6326 8.28342 11.5408 8.16359 11.4251L5.07275 8.44214",
    stroke: "#948B9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadDisabledIcon);
export default __webpack_public_path__ + "static/media/download-disabled-icon.32e406b77e48ad6f6cfc42f6d7bd9752.svg";
export { ForwardRef as ReactComponent };